import { type FunctionComponent, type SVGProps } from 'react';

export type SvgIconProps = SVGProps<SVGSVGElement>;

export const SvgIcon: FunctionComponent<SvgIconProps> = ({ ...props }) => {
  return (
    <svg
      fill="currentcolor"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      {...props}
    />
  );
};
